<template>
  <!-- 关联用--所属院校专题 -->
  <!--用于父组件中展示的UI-->
  <el-row>
    <el-col :span="24">
      <!-- 切换卡  切换类型对应表格 -->
      <el-select
        style="width: 300px"
        v-model="typeValue"
        class="m-2"
        placeholder="请选择关联类别"
        size="large"
        @change="changeType"
      >
        <el-option
          @click="changeType"
          v-for="item in specialTypesList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
    </el-col>
  </el-row>
  <!-- 关联专题 -->
  <el-dialog
    class="dialogMain"
    :close-on-click-modal="false"
    :model-value="ProjectVisible"
    title="关联专题"
    width="900px"
    append-to-body
    draggable
    destroy-on-close
  >
    <ProjectRelevancy
      v-if="ProjectVisible"
      @change-project="changeProject"
      @close-dialog="closeDialog"
      :idsArray="projectIds"
      :type="typeValue"
    ></ProjectRelevancy>
  </el-dialog>
  <!-- 关联普本院校 -->
  <el-dialog
    class="dialogMain"
    :close-on-click-modal="false"
    :model-value="PbSchoolVisible"
    title="关联普本院校"
    width="900px"
    draggable
    append-to-body
    destroy-on-close
  >
    <PbSchoolRelevancy
      v-if="PbSchoolVisible"
      @change-pbschool="changePbschool"
      is-select-table="true"
      @close-dialog="closeDialog"
      :idsArray="pbschoolIds"
      :type="typeValue"
    ></PbSchoolRelevancy>
  </el-dialog>
  <!-- 关联非普本院校 -->
  <el-dialog
    class="dialogMain"
    :close-on-click-modal="false"
    :model-value="NotpbSchoolVisible"
    title="关联非普本院校"
    append-to-body
    width="900px"
    draggable
    destroy-on-close
  >
    <NotpbSchoolRelevancy
      v-if="NotpbSchoolVisible"
      @change-not-pbschool="changeNotPbschool"
      @close-dialog="closeDialog"
      :idsArray="notpbschoolIds"
      :type="typeValue"
    ></NotpbSchoolRelevancy>
  </el-dialog>
  <div class="tableBox" v-if="relevanceTableData.length > 0">
    <el-table
      :data="relevanceTableData"
      border
      style="width: 100%; height: 315px"
      :header-cell-style="{ background: '#f5f7fa' }"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '8px' }"
    >
      <el-table-column prop="typeName" label="关联类型" align="center" width="180" />
      <el-table-column prop="name" label="名称" align="center">
        <template #default="scope">
          <span v-if="scope.row.name == null" class="gray">未设置</span>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template #default="scope">
          <el-button
            type="danger"
            size="default"
            plain
            @click="deleteFnc(scope.row, $event)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs, watch, toRaw, computed, nextTick } from "vue";
import ProjectRelevancy from "components/ProjectRelevancy.vue";
import PbSchoolRelevancy from "components/PbSchoolRelevancy.vue";
import NotpbSchoolRelevancy from "components/NotpbSchoolRelevancy.vue";
import { removeList } from "common/utils.js";

export default {
  name: "SchoolProjects",
  props: {
    specialTypesList: Array,
    channelList: Array,
  },
  components: {
    ProjectRelevancy,
    PbSchoolRelevancy,
    NotpbSchoolRelevancy,
  },

  setup(props, { emit }) {
    const data = reactive({
      typeValue: "",
      ProjectVisible: false,
      PbSchoolVisible: false,
      NotpbSchoolVisible: false,
      relevanceTableData: [], //选择关联院校专题三个组件总数据
      projectIds: [],
      pbschoolIds: [],
      notpbschoolIds: [],
      projectData: [],
      pbschoolData: [],
      notpbschoolData: [],
      ids1: [],
      ids2: [],
      ids3: [],
    });
    watch(props, (newProps) => {
      const channelList = JSON.parse(JSON.stringify(newProps)).channelList;
      const specialTypesList = JSON.parse(JSON.stringify(newProps)).specialTypesList;
      if (channelList && channelList.length > 0 && specialTypesList) {
        // if( data.relevanceTableData )
        relevanceList(channelList);
        // 格式化类型
        for (let i = 0; i < channelList.length; i++) {
          for (let j = 0; j < specialTypesList.length; j++) {
            if (channelList[i].relevanceType == specialTypesList[j].key) {
              channelList[i].relevanceTypeName = specialTypesList[j].value;
            }
          }
        }
        // 格式化表格
        // 新数组,用来装数据
        var newArr = [];
        channelList.map(function (sel, index) {
          var sevm = {};
          sevm["id"] = sel.relevanceId;
          sevm["type"] = sel.relevanceType;
          sevm["typeName"] = sel.relevanceTypeName;
          sevm["name"] = sel.relevanceName;
          newArr[index] = sevm;
        });
        data.relevanceTableData = newArr;
        data.projectData = [];
        data.pbschoolData = [];
        data.notpbschoolData = [];
        data.relevanceTableData.forEach((item) => {
          if (item.typeName == "专题") {
            data.projectData.push(item);
          }
          if (item.typeName == "普本") {
            data.pbschoolData.push(item);
          }
          if (item.typeName == "成教/网教/自考") {
            data.notpbschoolData.push(item);
          }
        });
      }
    });
    onMounted(() => {});

    function relevanceList(arr) {
      data.projectIds = [];
      data.pbschoolIds = [];
      data.notpbschoolIds = [];
      data.ids1 = [];
      data.ids2 = [];
      data.ids3 = [];
      arr.forEach((item) => {
        if (item.relevanceType == 1) {
          data.projectIds.push(item.relevanceId);
        }
        if (item.relevanceType == 2) {
          data.pbschoolIds.push(item.relevanceId);
        }
        if (item.relevanceType == 3) {
          data.notpbschoolIds.push(item.relevanceId);
        }
      });
    }

    //选择关联类别
    const changeType = () => {
      if (data.typeValue == 1) {
        data.ProjectVisible = true;
      }
      if (data.typeValue == 2) {
        data.PbSchoolVisible = true;
      }
      if (data.typeValue == 3) {
        data.NotpbSchoolVisible = true;
      }
    };

    //关闭弹窗
    const closeDialog = () => {
      data.ProjectVisible = false;
      data.PbSchoolVisible = false;
      data.NotpbSchoolVisible = false;
    };
    //专题列表组件传过来的值
    const changeProject = (sel) => {
      data.projectData = sel;
      data.projectIds = [];
      data.projectData.forEach((item) => {
        data.projectIds.push(item.id);
      });
      mergeThreeTable();
    };
    //普本院校列表组件传过来的值
    const changePbschool = (sel) => {
      data.pbschoolData = sel;
      data.pbschoolIds = [];
      data.pbschoolData.forEach((item) => {
        data.pbschoolIds.push(item.id);
      });
      mergeThreeTable();
    };
    //非普本院校列表组件传过来的值
    const changeNotPbschool = (sel) => {
      data.notpbschoolData = sel;
      data.notpbschoolIds = [];
      data.notpbschoolData.forEach((item) => {
        data.notpbschoolIds.push(item.id);
      });
      mergeThreeTable();
    };
    function mergeThreeTable() {
      const list = toRaw(data.projectData)
        .concat(toRaw(data.pbschoolData))
        .concat(toRaw(data.notpbschoolData));
      const arrObj = [...data.relevanceTableData, ...list];
      const map = new Map();
      const newArr = arrObj.filter((v) => !map.has(v.id) && map.set(v.id, 1));
      data.relevanceTableData = newArr
      emit("change-channel", data.relevanceTableData);
    }

    //删除关联专题及院校
    const deleteFnc = (row) => {
      var delRow = toRaw(row);
      data.relevanceTableData.map((item, index) => {
        if (
          item.id == delRow.id &&
          item.typeName == delRow.typeName &&
          item.name == delRow.name
        ) {
          data.relevanceTableData.splice(index, 1);
        }
      });
      data.projectData.map((item, index) => {
        if (
          item.id == delRow.id &&
          item.typeName == delRow.typeName &&
          item.name == delRow.name
        ) {
          data.projectData.splice(index, 1);
        }
      });
      data.projectIds = [];
      data.relevanceTableData.forEach((group) => {
        data.projectIds.push(group.id);
      });
      data.relevanceTableData.map((item, index) => {
        if (
          item.id == delRow.id &&
          item.typeName == delRow.typeName &&
          item.name == delRow.name
        ) {
          data.relevanceTableData.splice(index, 1);
        }
      });
      data.pbschoolData.map((item, index) => {
        if (
          item.id == delRow.id &&
          item.typeName == delRow.typeName &&
          item.name == delRow.name
        ) {
          data.pbschoolData.splice(index, 1);
        }
      });
      data.pbschoolIds = [];
      data.relevanceTableData.forEach((group) => {
        data.pbschoolIds.push(group.id);
      });
      data.relevanceTableData.map((item, index) => {
        if (
          item.id == delRow.id &&
          item.typeName == delRow.typeName &&
          item.name == delRow.name
        ) {
          data.relevanceTableData.splice(index, 1);
        }
      });
      data.notpbschoolData.map((item, index) => {
        if (
          item.id == delRow.id &&
          item.typeName == delRow.typeName &&
          item.name == delRow.name
        ) {
          data.notpbschoolData.splice(index, 1);
        }
      });
      data.notpbschoolIds = [];
      data.relevanceTableData.forEach((group) => {
        data.notpbschoolIds.push(group.id);
      });
      emit("change-channel", data.relevanceTableData);
    };

    return {
      ...toRefs(data),
      changeType,
      closeDialog,
      changeProject,
      changePbschool,
      changeNotPbschool,
      deleteFnc,
    };
  },
};
</script>
<style scoped>
.relevancy_btn {
  width: 330px;
}

.table_dialog {
  position: relative;
  margin-bottom: 30px;
}

.table_dialog .bottomTool {
  position: absolute;
  bottom: -45px;
  right: 0;
}

.choose_bom {
  margin-top: 74px;
  line-height: 35px;
}

.select_red {
  color: red;
}

/* 深度选择器 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
}

.type_lable {
  line-height: 38px;
  margin-right: 16px;
}

.tableBox {
  width: 100%;
  margin-top: 12px;
}
.dialogMain ::v-deep.el-overlay {
  background: transparent !important;
}
</style>
